import R from 'ramda'

const withDash = l => l.join('_')
const toMinMax = a => {return {min:a[0], max: a[1]} }
const parse = n => parseInt(n, 10)
const s2MinMax = (o, defaultResult) => R.ifElse(R.isNil, _ => defaultResult , R.pipe(R.defaultTo(''), R.split('_'), R.map(parse), toMinMax))(o)

const listOfIntsAsStr = (s) => {
  if(!s) {return []}
  const l = R.split('_', s)
  return R.map(s => parseInt(s, 10), l)
}

const listOfStrsAsStr = (s) => {
  if(!s) {return []}
  return R.split('_', s)
}

const boolToStr = (b) => b ? 't' : 'f'
const strToBool = (s) => s == 't'
export const poiToString = (poi) => `${poi.description}_pt${poi.type}@${R.path(['coordinates', 'lat'], poi)},${R.path(['coordinates','lng'], poi)}_o${poi.isOpen ? 't' : 'f'}_ef${poi.isEditingFrequency ? 't' : 'f'}_tt${poi.transportationType}_td${poi.travelDuration}_f${poi.frequency}_a${poi.arrivalTime}_d${poi.departureTime}_mc${poi.markerCount}`
const stringToPoi = (s) => {
  const exps = {
    description : {exp: /^(.*)_pt/, default: ""},
    type: {exp: /_pt(.*)@/, default: ""},
    lat: {exp: /@(-?\d*.\d*),/, parse: n => parseFloat(n, 10), default: 0},
    lng: {exp:/,(-?\d*.\d*)_/, parse: n => parseFloat(n, 10), default: 0},
    isOpen: {exp:/_o([t|f])_/, parse: v => v == 't', default: false},
    isEditingFrequency: {exp: /_ef([t|f])_/, parse: v => v == 't', default: false},
    transportationType: { exp: /_tt(\S|)_/, default: 'D'},
    travelDuration: {exp: /_td(\d*)_/, parse: (n => parseInt(n, 10)), default: 30},
    frequency: {exp: /_f(\d{7})_/, default: "1111100"},
    arrivalTime: {exp: /_a(\d\d:\d\d)_/, default: "08:00"},
    departureTime: {exp: /_d(\d\d:\d\d)_/, default: "17:00"},
    markerCount: { exp: /_mc(\S|)/, default: '1'}
  }

  const m = R.map( entry => {
    const match = s.match(entry.exp) || []
    const v = R.nth(1, match)
    if(R.isNil(v)) { return entry.default }
    if(entry.parse){ return entry.parse(v) }
    return v
  }, exps)

  return {
    description: m.description,
    coordinates: {
      lat: m.lat,
      lng: m.lng,
    },
    type: m.type,
    isOpen: m.isOpen,
    isEditingFrequency: m.isEditingFrequency,
    transportationType: m.transportationType,
    travelDuration: m.travelDuration,
    frequency: m.frequency,
    arrivalTime: m.arrivalTime,
    departureTime: m.departureTime,
    markerCount: m.markerCount
  }
}
export const toQueryObject = (q) => {
  return {
    prices: q.features.prices ? withDash([q.features.prices.min, q.features.prices.max]) : null,
    areas: q.features.areas ? withDash([q.features.areas.min, q.features.areas.max]) : null,
    provinces: withDash(q.provinces) || [],
    regions: withDash(q.regions) || [],
    towns: withDash(q.towns) || [],
    estateTypes: withDash(q.features.estateTypes) || [],
    rooms:q.options.rooms || 0,
    bathrooms:q.options.bathrooms || 0,
    rental: boolToStr(q.features.rental),
    garage: boolToStr(q.options.garage),
    garden: boolToStr(q.options.garden),
    swimmingPool: boolToStr(q.options.swimmingPool),
    terrace: boolToStr(q.options.terrace),
    newOnly: boolToStr(q.options.newOnly),
    likedOnly: boolToStr(q.options.likedOnly),
    pois: q.pois ? R.map(poiToString, q.pois).join("|") : [],
  }
}

export const fromQueryObject = (o) => {

  const rental = strToBool(o.rental)
  const priceRange = rental ? {min: 0, max: 5000} : {min: 0, max: 3000000}

  return {
    provinces: listOfIntsAsStr(o.provinces),
    regions: listOfIntsAsStr(o.regions),
    towns: listOfIntsAsStr(o.towns),
    features: {
      rental: rental,
      areas: s2MinMax(o.areas, {min: 0, max: 2000}),
      prices: s2MinMax(o.prices, priceRange),
      estateTypes:listOfStrsAsStr(o.estateTypes),
    },
    options: {
      rooms: parseInt(o.rooms || 0),
      bathrooms: parseInt(o.bathrooms || 0),
      garage: strToBool(o.garage),
      garden: strToBool(o.garden),

      swimmingPool: strToBool(o.swimmingPool),
      terrace: strToBool(o.terrace),
      newOnly: strToBool(o.newOnly),
      likedOnly: strToBool(o.likedOnly),
    },
    pois: o.pois ? R.map(stringToPoi, o.pois.split("|")) : [],
  }
}



/** WEBPACK FOOTER **
 ** ./app/utils/queryObjectMapper.js
 **/